import { updateProjectNameMutationOptions } from "#api/migrate-web/routes/projects.ts";
import { tenantInfoQueryOptions } from "#api/routes/tenant-infos.ts";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

export function useRenameProjectToTenantName(projectId: string, tenantId: string | undefined, hasTenant: boolean) {
    const tenantInfo = useQuery({
        ...tenantInfoQueryOptions(tenantId ?? ""),
        enabled: hasTenant && tenantId !== undefined
    });
    const renameProject = useMutation(updateProjectNameMutationOptions());
    const hasRenamedRef = useRef(false);

    useEffect(() => {
        if (tenantInfo.data && !hasRenamedRef.current) {
            hasRenamedRef.current = true;
            renameProject.mutate({ params: { path: { projectId } }, body: { name: tenantInfo.data.displayName } });
        }
    }, [tenantInfo.data, renameProject, projectId]);
}
